import {CxEvent} from '@spartacus/core';
import {EddlCollectionState} from './../models/eddl-adobe-tracking-data';

export class EddlMergedAbstract extends CxEvent {
  static readonly type: string;
  collectState?: EddlCollectionState;
  collectToken?: string;
  collectOrder?: number;
  pushManually?: boolean;
}
